import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { requestedProductsTypes } from 'actions/types'

const initialState = []
const baseType = requestedProductsTypes.FETCH_REQUESTED_PRODUCTS

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
